import { useMemo } from "react";
import WithDrawCrypto from "./components/WithDrawCrypto";
import WithDrawSOT from "./components/WithDrawSOT";
import { useSearchParams } from "react-router-dom";
import { TYPE_WALLET_DETAIL } from "../../constants";
import WithDrawGameCurrency from "./components/WithDrawGameCurrency";

const WithDraw = () => {
  const [searchParams] = useSearchParams();
  const type = useMemo(() => {
    const type = searchParams.get("type");
    return type || TYPE_WALLET_DETAIL.CRYPTO;
  }, [searchParams]);

  const renderView = () => {
    switch (type) {
      case TYPE_WALLET_DETAIL.CRYPTO:
        return <WithDrawCrypto />;
      case TYPE_WALLET_DETAIL.OPTION:
        return <WithDrawSOT />;
      case TYPE_WALLET_DETAIL.GAMECURRENCY:
      case TYPE_WALLET_DETAIL.COMMISSION:
        return <WithDrawGameCurrency />;
      default:
        return null;
    }
  };
  return <div>{renderView()}</div>;
};
export default WithDraw;
